const configure = {
    "REGION": process.env.REACT_APP_Cognito_Region,
    "USER_POOL_ID": process.env.REACT_APP_Cognito_UP_ID,
    "USER_POOL_APP_CLIENT_ID": process.env.REACT_APP_Cognito_Client_ID
}

export default configure;